import { ISMSCommunication } from 'shared';

import { Drawer } from '../../../../common/Atoms/Drawer';
import { SmsReplyComposer } from '../../Molecules/SmsReplyComposer';
import { formatInboxDate } from '../common/formatInboxDate';
import { SmsCommunication } from '../../CRM/ContactPage/ContactTableSection/Communications/SmsCommunication';

interface SmsInboxMessageDrawerProps {
  sms: ISMSCommunication | null;
  likelyOriginalOutbound: ISMSCommunication | null;
  manualOutboundAfter: ISMSCommunication | null;
  organisationId?: string;
  open: boolean;
  onSent?: () => Promise<unknown> | unknown;
  onClose: () => void;
}

export function SmsInboxMessageDrawer({
  sms,
  likelyOriginalOutbound,
  manualOutboundAfter,
  organisationId,
  open,
  onSent,
  onClose,
}: SmsInboxMessageDrawerProps) {
  const hasSmsDestination = !!sms?.from;
  const sendSmsDisabledReason = sms?.contactId
    ? hasSmsDestination ? `` : `No phone number available to send SMS to.`
    : `No matched contact found for this SMS.`;

  return (
    <Drawer
      title={ `SMS Message` }
      open={ open }
      setOpen={ isOpen => {
        if (!isOpen) {
          onClose();
        }
      } }
      size={ `lg` }
    >
      { sms ? (
        <div className={ `space-y-5` }>
          <div className={ `rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700` }>
            <div className={ `mb-1` }>
              <span className={ `font-semibold` }>{ `Received: ` }</span>
              { formatInboxDate(sms.createdAt) }
            </div>
            <div className={ `mb-1` }>
              <span className={ `font-semibold` }>{ `From: ` }</span>
              { sms.from || `-` }
            </div>
            <div>
              <span className={ `font-semibold` }>{ `Contact: ` }</span>
              { sms.contactName || (sms.contactId ? `Contact #${sms.contactId}` : `-`) }
            </div>
          </div>

          <div className={ `space-y-4` }>
            { [likelyOriginalOutbound, sms, manualOutboundAfter]
              .filter((message): message is ISMSCommunication => !!message)
              .filter((message, idx, all) => all.findIndex(item => item.id === message.id) === idx)
              .sort((a, b) => {
                const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
                const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;

                return aTime - bTime;
              })
              .map((message, idx) => (
                <SmsCommunication
                  key={ `${message.id}-${idx}` }
                  sms={ message }
                />
              )) }
          </div>

          <SmsReplyComposer
            organisationId={ organisationId }
            contactId={ sms.contactId }
            destinationNumber={ sms.from }
            hasSmsDestination={ hasSmsDestination && !!sms.contactId }
            sendSmsDisabledReason={ sendSmsDisabledReason }
            onSent={ onSent }
          />
        </div>
      ) : null }
    </Drawer>
  );
}
